<router-outlet></router-outlet>
<div
    class="modal"
    tabindex="-1"
    role="dialog"
    [ngStyle]="{ display: modalDisplay }"
>
    <div
        class="modal-dialog modal-dialog-centered justify-content-center"
        role="document"
        style="max-width: 600px; width: 100%"
    >
        <div class="modal-content text-left p-4">
          
            <div class="modal-body">

           <h3 class="text-center mb-3 modal-title">Note</h3>
                <p class="my-4 text-gray-800">
                    Your password has expired. Please update your password to
                    continue.
                    
                </p>
                <div class="text-right">
                    <button
                        mat-flat-button
                        color="primary"
                        (click)="goToPasswordUpdate()"
                    >
                        Update Password
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>


